// 统计卡片组件
import { Card, Skeleton } from '@arco-design/web-react'
import { TrendingUp, TrendingDown } from 'lucide-react'
import { ReactNode } from 'react'

interface StatCardProps {
  title: string
  value: string | number
  trend?: number
  icon?: ReactNode
  loading?: boolean
  iconBgClass?: string
  iconTextClass?: string
}

export default function StatCard({
  title,
  value,
  trend = 0,
  icon,
  loading = false,
  iconBgClass = 'bg-[rgba(37,99,235,0.12)]',
  iconTextClass = 'text-[#2563EB]',
}: StatCardProps) {
  return (
    <Card className="h-full !rounded-2xl !border !border-[#EAECEF] !shadow-[0_4px_20px_rgba(15,23,42,0.03)] !bg-white">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <p className="text-[13px] text-[#9CA3AF] font-medium">{title}</p>
          {loading ? (
            <Skeleton text={{ rows: 1, width: '60%' }} animation />
          ) : (
            <>
              <p className="text-[28px] leading-tight font-semibold text-[#111827] mt-2">{value}</p>
              {trend !== 0 && (
                <p className={`text-xs mt-2 flex items-center ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {trend >= 0 ? <TrendingUp size={14} className="mr-1" /> : <TrendingDown size={14} className="mr-1" />}
                  {Math.abs(trend)}%
                </p>
              )}
            </>
          )}
        </div>
        {icon && (
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${iconBgClass} ${iconTextClass}`}>
            <div className="w-5 h-5">{icon}</div>
          </div>
        )}
      </div>
    </Card>
  )
}
